import { Menu } from "@wrstudios/components";
import styled from "styled-components";

export const MenuButton = styled(Menu.Button)`
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: ${({ theme, isHighlighted }) =>
    isHighlighted ? theme.prevColors.streamsBlue : theme.prevColors.grey};

  svg {
    width: 2.1rem;
    height: 2.1rem;
    fill: ${({ theme }) => theme.prevColors.grey};
  }
`;

export const MenuButtonIcon = styled.span`
  margin-right: 0.6rem;
`;
